import { Button, CircularProgress, Typography } from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import TextField from "@material-ui/core/TextField";
import Assignment from "@material-ui/icons/Assignment";
import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { showPopupSnackbar } from "../redux/actions/snackbarActions";
import { validateDateType } from "../Utils/Common";
import { useStyles } from "../Utils/Styles";

export default function DateSelect(props) {
  const classes = useStyles();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  return (
    <Grid item xs={12}>
      <Paper
        className={classes.paper}
        style={{
          alignItems: "center",
          justifyContent: "space-evenly",
          flexDirection: "row",
        }}
      >
        {props.handlePdf ? (
          <Button onClick={props.handlePdf}>
            <Assignment />
            <Typography>{t("transportDetails.downloadPDF")}</Typography>
          </Button>
        ) : undefined}
        {props.oneDate ? (
          <TextField
            id="date"
            label={t("monitoring.date")}
            type="date"
            defaultValue={props.selectedDate?.substr(0, 10)}
            className={classes.textField}
            InputLabelProps={{
              shrink: true,
            }}
            onChange={props.handleDate}
            xs={12}
            sm={4}
          />
        ) : (
          <React.Fragment>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                minHeight: 50,
                margin: 5,
              }}
            >
              <TextField
                id="rangeStartDate"
                label={t("monitoring.rangeStartDate")}
                type="date"
                defaultValue={props.selectedDate?.substr(0, 10)}
                className={classes.textField}
                InputLabelProps={{
                  shrink: true,
                }}
                onChange={(e) => {
                  if (validateDateType(e.target.value, "date")) {
                    props.setDate(e.target.value);
                  } else {
                    if (process.env.NODE_ENV !== "production") {
                      console.log(e.target.value);
                    }
                  }
                }}
                xs={12}
                sm={4}
              />
              <TextField
                id="rangeStartTime"
                label={t("monitoring.rangeStartTime")}
                type="time"
                className={classes.textField}
                style={{ marginTop: 5 }}
                InputLabelProps={{
                  shrink: true,
                }}
                onChange={(e) => {
                  if (validateDateType(e.target.value, "time")) {
                    props.setRangeStartTime(e.target.value);
                  } else {
                    if (process.env.NODE_ENV !== "production") {
                      console.log(e.target.value);
                    }
                  }
                }}
                xs={12}
                sm={4}
              />
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                minHeight: 50,
                margin: 5,
              }}
            >
              <TextField
                id="rangeEndDate"
                label={t("monitoring.rangeEndDate")}
                type="date"
                className={classes.textField}
                InputLabelProps={{
                  shrink: true,
                }}
                onChange={(e) => {
                  if (validateDateType(e.target.value, "date")) {
                    if (
                      props.selectedDate === undefined ||
                      e.target.value >= props.selectedDate
                    ) {
                      props.setRangeEndDate(e.target.value);
                    } else {
                      dispatch(
                        showPopupSnackbar({
                          error: true,
                          message: "Invalid date range",
                        })
                      );
                    }
                  } else {
                    if (process.env.NODE_ENV !== "production") {
                      console.log(e.target.value);
                    }
                  }
                }}
                xs={12}
                sm={4}
              />
              <TextField
                id="rangeEndTime"
                label={t("monitoring.rangeEndTime")}
                type="time"
                className={classes.textField}
                style={{ marginTop: 5 }}
                InputLabelProps={{
                  shrink: true,
                }}
                onChange={(e) => {
                  if (validateDateType(e.target.value, "time")) {
                    if (props.selectedDate === props.rangeEndDate) {
                      if (e.target.value > props.rangeStartTime) {
                        props.setRangeEndTime(e.target.value);
                      } else {
                        dispatch(
                          showPopupSnackbar({
                            error: true,
                            message: "Invalid time range",
                          })
                        );
                      }
                    } else {
                      props.setRangeEndTime(e.target.value);
                    }
                  } else {
                    if (process.env.NODE_ENV !== "production") {
                      console.log(e.target.value);
                    }
                  }
                }}
                xs={12}
                sm={4}
              />
            </div>
          </React.Fragment>
        )}
        {props.handleSubmit ? (
          <Button
            style={{ height: 45 }}
            variant="outlined"
            onClick={props.handleSubmit}
          >
            {t("monitoring.submitDates")}
          </Button>
        ) : undefined}
        {props.activityIndicator ? (
          <CircularProgress> </CircularProgress>
        ) : undefined}
        {props.setOneDate ? (
          <Button
            style={{ height: 45 }}
            variant="outlined"
            onClick={() => {
              props.setOneDate(!props.oneDate);
              if (!props.oneDate) {
                props.setRangeEndDate();
                props.setRangeEndTime();
                props.setRangeStartTime();
              }
            }}
          >
            {props.oneDate ? t("monitoring.range") : t("monitoring.date")}
          </Button>
        ) : undefined}
      </Paper>
    </Grid>
  );
}
